import type { ITheme } from "@app/app/components/ThemeProvider";
import { ICurrency, IFilterGroup, IImage, ILanguage } from "@app/common/types";
import { IProperty, IPropertyTheme } from "@app/property/types";

export enum IPropertyGroupMethod {
    UrlEndsWith = "UrlEndsWith",
    UrlStartsWith = "UrlStartsWith",
    UrlContains = "UrlContains",
    WindowObject = "WindowObject",
}

interface IPropertyDetection {
    method: IPropertyGroupMethod;
    properties: {
        [key: string]: string;
    };
    windowKey?: string;
}

export interface IPropertyGroup {
    domain: string;
    properties: IProperty[];
    property_detection: IPropertyDetection;
    fallback_theme_config: ITheme;
    fallback_theme: IPropertyTheme;
    fallback_languages: ILanguage[];
    fallback_currencies: ICurrency[];
    filter_groups: IFilterGroup[];
    current_page: number;
    has_more_data: boolean;
}

// Map-specific property data interfaces
export interface IPropertyMapData {
    id: string;
    external_id: string;
    name: string;
    description: Record<string, string> | null;
    coordinates: {
        lat: number | null;
        lng: number | null;
    };
    cover_image: IImage | null;
    sequence: number;
    currency: string;
    locale: string;
    min_rate: number | null;
}
